var _path, _path2, _path3, _path4, _path5, _g, _g2, _path6, _g3, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWhiteLogo = function SvgWhiteLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M34.5004 23.0007H26.6671C25.6947 23.0007 24.7621 23.387 24.0746 24.0746C23.387 24.7621 23.0007 25.6947 23.0007 26.6671V34.5004H34.5004V23.0007Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M11.4998 34.5005V42.3338C11.5001 43.3063 11.8867 44.2389 12.5745 44.9264C13.2622 45.6139 14.1949 46.0002 15.1674 46.0002H23.0008V34.5005H11.4998Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5005 34.5004H42.3338C42.8153 34.5004 43.2921 34.4056 43.7369 34.2213C44.1817 34.0371 44.5859 33.767 44.9263 33.4266C45.2668 33.0861 45.5368 32.6819 45.7211 32.2371C45.9053 31.7923 46.0002 31.3155 46.0002 30.8341V23.0007H34.5005V34.5004Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M46.0002 23.0008V15.1674C46.0002 14.1949 45.6139 13.2622 44.9264 12.5745C44.2389 11.8867 43.3063 11.5001 42.3338 11.4998H34.5005V23.0008H46.0002Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0007 46.0002H30.8341C31.3155 46.0002 31.7923 45.9053 32.2371 45.7211C32.6819 45.5368 33.0861 45.2668 33.4266 44.9263C33.767 44.5859 34.0371 44.1817 34.2213 43.7369C34.4056 43.2921 34.5004 42.8153 34.5004 42.3338V34.5005H23.0007V46.0002Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M11.4998 23.0008H19.3384C20.3093 22.9993 21.24 22.613 21.9265 21.9265C22.613 21.24 22.9993 20.3093 23.0008 19.3384V11.4998H11.4998V23.0008Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M34.5004 11.4997V3.66633C34.5004 2.69396 34.1141 1.76141 33.4266 1.07384C32.739 0.386273 31.8064 0 30.8341 0L23.0007 0V11.4997H34.5004Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4997 11.4998H3.66633C2.69384 11.5001 1.76129 11.8867 1.07376 12.5745C0.386231 13.2622 -6.34177e-08 14.1949 0 15.1674V23.0008H11.4997V11.4998Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M0 23.0007V30.8341C0 31.8064 0.386273 32.739 1.07384 33.4266C1.76141 34.1141 2.69396 34.5004 3.66633 34.5004H11.4997V23.0007H0Z",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0008 0H15.1674C14.1949 -6.34177e-08 13.2622 0.386231 12.5745 1.07376C11.8867 1.76129 11.5001 2.69384 11.4998 3.66633V11.4997H23.0008V0Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWhiteLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "white-logo.df924cec671f52f31535ee5af7abe7fc.svg";